// extracted by mini-css-extract-plugin
module.exports = {"selectCourses":"style__selectCourses__equSd","courseToggles":"style__courseToggles__2CVYi","tableContainer":"style__tableContainer__Urrgs"};